export const redirect = (uri) => window.location.replace(uri);

export const openPopup = (
  uri,
  name,
  width = screen.width,
  height = screen.height,
) => {
  const left = screen.width / 2 - width / 2;
  const top = screen.height / 2 - height / 2;
  const popup = window.open(
    uri,
    name,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
  );
  if (popup) {
    popup.focus();
  }
  return popup;
};
